import { LoadingButton } from "@mui/lab";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SendIcon from "@mui/icons-material/Send";
import { useTranslation } from "react-i18next";

type DynamicBulkInviteButtonProps = {
  allEntriesAreValid: boolean;
  allInvitesSent: boolean;
  necessarySelectionsMade: boolean;
  revalidate: () => void;
  invite: () => void;
  loading: boolean;
  validating: boolean;
};

export const DynamicBulkInviteButton = ({
  allEntriesAreValid,
  necessarySelectionsMade,
  revalidate,
  loading,
  validating,
  invite,
  allInvitesSent
}: DynamicBulkInviteButtonProps) => {
  const { t } = useTranslation();

  const buttonText = () => {
    let text = "Validate";
    if (allInvitesSent) {
      text = "Invites Sent";
    } else if (validating) {
      text = "Validating...";
    } else if (allEntriesAreValid) {
      text = "Invite All";
    }
    return text;
  };

  const buttonIcon = allInvitesSent ? (
    <CheckCircleOutlineIcon />
  ) : allEntriesAreValid ? (
    <SendIcon />
  ) : (
    <PublishedWithChangesIcon />
  );

  const clickBehavior = allEntriesAreValid ? invite : revalidate;
  return (
    <LoadingButton
      variant="contained"
      color="secondary"
      loading={loading}
      loadingPosition="start"
      onClick={() => clickBehavior()}
      startIcon={buttonIcon}
      disabled={!necessarySelectionsMade || loading || allInvitesSent}
      sx={{
        color: "white"
      }}
    >
      {t(buttonText())}
    </LoadingButton>
  );
};
